import { render } from "./StepNumber.vue?vue&type=template&id=7c9687fe&scoped=true&ts=true"
import script from "./StepNumber.vue?vue&type=script&lang=ts"
export * from "./StepNumber.vue?vue&type=script&lang=ts"

import "./StepNumber.vue?vue&type=style&index=0&id=7c9687fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9687fe"]])

export default __exports__